export const ATTACHMENT_SIZES = {
    GIG_ATTACHMENT_SMALL_PREVIEW: 'small',
    GIG_ATTACHMENT_MEDIUM_PREVIEW: 'medium',
    GIG_ATTACHMENT_ORIGINAL_PREVIEW: 'original',
};
